import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'filterSelection.title',
    defaultMessage: 'Filters',
    description: 'Filter selection drawer title',
  },
  resetButton: {
    id: 'filterSelection.resetButton',
    defaultMessage: 'Reset filters',
    description: 'The label of the reset filters button',
  },
  rowCount: {
    id: 'filterSelection.rowCount',
    defaultMessage: '{count} of {total}',
    description: 'Label of displayed filter row count',
  },
};

export default defineMessages(translations);
